import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { MainLayout } from './components/MainLayout';
import { HelmetProvider } from 'react-helmet-async';
import { Home } from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import CookiePolicy from './pages/CookiePolicy';
import ThankYouPage from './pages/ThankYouPage';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { localeConfig } from './i18n';

import './styles/custom.sass';

function LanguageDetector({ children }) {
  const { i18n } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    
    // Определяем текущий язык на основе URL
    const getCurrentLanguageFromPath = () => {
      // Проверяем каждую доступную локаль (кроме языка по умолчанию)
      for (const locale of localeConfig.availableLocales) {
        if (locale === localeConfig.defaultLocale) continue;
        
        if (path === `/${locale}` ||
            path.startsWith(`/${locale}/`) ||
            path.endsWith(`/${locale}`)) {
          return locale;
        }
      }
      
      // Если никакая локаль не найдена в URL, возвращаем язык по умолчанию
      return localeConfig.defaultLocale;
    };

    const currentLang = getCurrentLanguageFromPath();

    if (i18n.language !== currentLang) {
      i18n.changeLanguage(currentLang);
    }
  }, [location.pathname, i18n]);

  return children;
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <LanguageDetector>
          <Routes>
            <Route path='/' element={<MainLayout />}>
              <Route index element={<Home />} />
              
              {/* Русские роуты */}
              <Route path='ru' element={<Home />} />
              <Route path='privacy-policy/ru' element={<PrivacyPolicy />} />
              <Route path='terms-of-use/ru' element={<TermsOfUse />} />
              <Route path='cookie-policy/ru' element={<CookiePolicy />} />
              <Route path='thank-you/ru' element={<ThankYouPage />} />
              
              {/* Английские роуты */}
              <Route path='en' element={<Home />} />
              <Route path='privacy-policy/en' element={<PrivacyPolicy />} />
              <Route path='terms-of-use/en' element={<TermsOfUse />} />
              <Route path='cookie-policy/en' element={<CookiePolicy />} />
              <Route path='thank-you/en' element={<ThankYouPage />} />
              
              {/* Украинские роуты (язык по умолчанию) */}
              <Route path='privacy-policy' element={<PrivacyPolicy />} />
              <Route path='terms-of-use' element={<TermsOfUse />} />
              <Route path='cookie-policy' element={<CookiePolicy />} />
              <Route path='thank-you' element={<ThankYouPage />} />
            </Route>
          </Routes>
        </LanguageDetector>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export { App };
